import { Schema } from "effect";
export const MissionControlConfig = Schema.Struct({
    translationEnabled: Schema.optionalWith(Schema.Boolean, {
        default: () => false,
    }),
});
